import React from 'react'
import styles from './styles.module.scss'
import ActionButton from '@/src/components/misc/action-elements/action-button/action-button'
import { useCategory } from '@/src/context/category/category-context'

export default function NoProductsFound() {
    const { setCategoriesBySearch } = useCategory()
    return (
        <div className={styles.container}>
            <h3>Nenhum produto encontrado</h3>
            <ActionButton onClick={() => setCategoriesBySearch(undefined)} size='medium'>Ver todos os produtos</ActionButton>
        </div>
    )
}
